import {
  Dispatch,
  SetStateAction,
  useContext,
  useRef,
  useState,
  useEffect,
} from 'react'
import { Icon } from 'assets/index'
import { UserContext } from 'context/userContext'
import {
  Modal,
  Background,
  ChildrenContainer,
  ContentContainer,
  PathContainer,
} from './style'
import { ButtonNext } from '..'

interface IModal {
  showModal: boolean
  setShowModal: Dispatch<SetStateAction<boolean>>
  children: any
  buttonDisabled?: boolean
  backButton?: boolean
  onClose?: () => void
}

export default function ModalComponent(props: IModal) {
  const { setClientOption, setExtended } = useContext(UserContext)
  const { showModal, children, setShowModal, backButton, onClose } = props
  const [page, setPage] = useState<number>(0)
  const backgroundRef = useRef<HTMLDivElement>(null)

  function closeModal(): void {
    onClose && onClose()
    setClientOption('')
    setShowModal(false)
    setExtended(false)
  }

  useEffect(() => {
    setPage(0)
  }, [showModal])

  const handleClickBackground = (e: any) => {
    if (backgroundRef.current === e.target) {
      closeModal()
    }
  }

  const advanceTablePage = () => {
    children[page][2]()
    if (page === children.length - 1) {
      return
    }
    setPage((oldValue) => oldValue + 1)
  }

  const backTablePage = () => {
    children[page][3]()
    if (page === 0) return
    setPage((oldValue) => oldValue - 1)
  }

  return showModal ? (
    <Background ref={backgroundRef} onClick={handleClickBackground}>
      <Modal {...props}>
        <ChildrenContainer>
          <PathContainer className="path">
            <span className="path">
              {backButton ? (
                <img
                  id="button-back-modal"
                  onClick={() => setClientOption('')}
                  src={Icon('chevron_left.svg')}
                  alt="back modal"
                  className="close-modal"
                />
              ) : (
                ''
              )}
              {children[page][1]}
            </span>
            <img
              onClick={() => closeModal()}
              src={Icon('x.svg')}
              alt="close modal"
              className="close-modal"
            />
          </PathContainer>
          <ContentContainer>{children[page][0]}</ContentContainer>
          {children.length === 1 ? null : (
            <ButtonNext
              isAdvance={page === 0}
              isBack={page === children.length - 1}
              advancePage={advanceTablePage}
              backPage={backTablePage}
            />
          )}
        </ChildrenContainer>
      </Modal>
    </Background>
  ) : null
}
